// Design tokens for the operator console.
//
// Ported from chat-service-dashboard-mock-ui/styles.css, which is the visual spec for every screen
// in phase 1.16. The mock holds these as :root custom properties; here they are a
// styled-components theme. Change them in one place, and keep the mock in step so it stays usable
// as a reference rather than becoming a stale picture of an older design.

export const theme = {
  color: {
    bg: "#f4f5f7",
    surface: "#ffffff",
    surfaceSunk: "#fafbfc",
    border: "#e6e8eb",
    borderStrong: "#dcdfe3",

    ink: "#16181b",
    ink2: "#3f454d",
    ink3: "#6b7280",
    ink4: "#8a8f98",

    accent: "#8f1f28",
    accentHover: "#7a1a22",
    accentTint: "#fdf3f4",
    accentBorder: "#e3b9bd",

    okBg: "#e8f5ec",
    okFg: "#1e7a42",
    warnBg: "#fdf3e3",
    warnFg: "#a86a12",
    badBg: "#fdeceb",
    badFg: "#b3261e",
    badBorder: "#f0cecb",
    neutralBg: "#eef1f6",
    neutralFg: "#4a5568",
    mutedBg: "#eff0f2",
    rowHover: "#fcfcfd",
    railActive: "#eef0f3",
    chipBg: "#f0f1f3",
    codeBg: "#f2f3f5",
    redactedBg: "#eceef0",
    secretBg: "#14161a",
    secretFg: "#e8eaed",

    infoBg: "#eef4fb",
    infoBorder: "#d6e3f3",
    infoStrong: "#1c4f8c",
    noteBg: "#fdf9ef",
    noteBorder: "#f0e4c8",
  },

  // Code blocks: a dark panel with coloured tokens, the way documentation sites draw code. The token
  // colours follow GitHub's dark theme. Used only by CodeBlock.
  syntax: {
    bg: "#0d1117",
    bar: "#161b22",
    border: "#30363d",
    text: "#e6edf3",
    muted: "#8b949e",
    keyword: "#ff7b72",
    string: "#a5d6ff",
    number: "#79c0ff",
    title: "#d2a8ff",
    attr: "#79c0ff",
    variable: "#ffa657",
    tag: "#7ee787",
  },

  radius: { md: "12px", sm: "8px" },
  rail: "70px",
  // The mock's two breakpoints (styles.css). Used ONLY inside shared components, via `media` below, so
  // one change fixes every screen. A media query in a page file is a missing variant.
  //   wide:   <= 1080px  three- and four-column grids go to two, page padding shrinks
  //   narrow: <= 720px   every grid goes to one column, the rail becomes a top bar, tables scroll
  breakpoint: { wide: 1080, narrow: 720 },
  // A top bar's height once the rail folds away on a phone.
  topbar: "56px",

  font: {
    // Newsreader for display, DM Sans for everything else. Two families, loaded in the layout.
    display: '"Newsreader", Georgia, serif',
    body: '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
  },
}

// `${media.narrow} { ... }` inside a styled component.
export const media = {
  wide: `@media (max-width: ${theme.breakpoint.wide}px)`,
  narrow: `@media (max-width: ${theme.breakpoint.narrow}px)`,
}

export default theme
